import { useTargetIdParam } from '../../hooks/use-target-id-param';
import { useSubmissionMode } from '../../hooks/use-submission-mode';
import { useStore } from '../../store/store';
import { BankIDoginForm } from '../authentication/components/bankid-login-form';
import S from '../authentication/styles';
import { useEffect } from 'react';
import { useMatchEmailDestination } from '../submit-email/hooks/use-match-email-destination';

export function HomeRoute() {
    const { targetId } = useTargetIdParam();
    const { submissionMode } = useSubmissionMode();
    const { emailDestination } = useMatchEmailDestination();

    const { setDestinationKey, setSendingFlow } = useStore(
        (state) => ({
            setDestinationKey: state.setDestinationKey,
            setSendingFlow: state.setSendingFlow,
        }),
    );

    useEffect(() => {
        if (targetId) {
            // For EMAIL flow: convert ID to email address
            // For CRM flow: use UUID directly
            if (submissionMode === 'EMAIL') {
                const email = emailDestination(targetId);
                setDestinationKey(email);
            } else {
                setDestinationKey(targetId);
            }
            
            setSendingFlow(submissionMode);
        }
    }, [targetId, submissionMode, emailDestination, setDestinationKey, setSendingFlow]);

    return (
        <>
            <>
                    <S.Heading>Samtykke</S.Heading>
                    <S.Subheading>
                    Ved å verifisere deg med   
Bank-ID kan vi hente dine   
data fra Gjeldsregisteret   
automatisk  
                    </S.Subheading>
                </>
           <BankIDoginForm />
        </>
    );
}
